module.exports = __webpack_public_path__ + "static/media/SCBpending.152a9206.svg";